<div class="list-group">
  <div class="list-group-item" *ngFor="let lesson of module.relationships.lessons.data">
    <h1 class="module-id">MODULE {{module.id}}</h1>
    <h1 class="module-title">{{lesson.attributes.title}}</h1>
  </div>
</div>
